var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { IconDownloadFile } from '@/presentation/components/icons';
import { IconButton } from '@/presentation/components';
import { downloadFile } from '@/main/utils/file-utils';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
const DownloadButton = ({ item, disabled, colorIcon = '#00A3FF' }) => {
    const [loading, setLoading] = useState(false);
    const { showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const downloadFileLocal = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield downloadFile(item === null || item === void 0 ? void 0 : item.fileS3Path, item === null || item === void 0 ? void 0 : item.originalFileName, {}, 'lesson-plans/');
        }
        catch (error) {
            console.error('error', error);
            showCustomError('Error', 'Error downloading file');
        }
        finally {
            setLoading(false);
        }
    });
    return (React.createElement(IconButton, { onClick: downloadFileLocal, loading: loading, disabled: disabled },
        React.createElement(IconDownloadFile, { color1: disabled ? 'gray' : colorIcon, width: 24, height: 24 })));
};
export default DownloadButton;
